import { Flex, Typography } from 'antd';
import { CopyOutlined, LikeOutlined } from '@ant-design/icons';

import { getCardDisplayName } from 'utilities/helpers';
import useAccountsInfo from 'hooks/useAccountsInfo';

const CreditAccountTitle = ({ extraContent }) => {
  const { account } = useAccountsInfo();

  return (
    <Flex
      justify="space-between"
      gap="var(--spacing)"
      style={{ width: '100%' }}
    >
      <Typography.Title
        className="account-name"
        level={4}
        style={{ margin: 0 }}
        copyable={{
          text: `${account?.cardDetails?.last4}`,
          tooltips: [
            'Copy Card Last 4',
            <span key="copied-message">
              Card Last 4 Copied <LikeOutlined />
            </span>,
          ],
          icon: [<CopyOutlined />, <CopyOutlined disabled={true} />],
        }}
      >
        {getCardDisplayName(account)}
      </Typography.Title>

      {extraContent}
    </Flex>
  );
};

export default CreditAccountTitle;
